import { SwapContainer } from '@/features/swap/SwapContainer'

export function Swap() {
  return <SwapContainer />
}
